import React__default from 'react';
import './FormGroup.scss.js';
import { classnames } from '../../../utils/classnames.js';

var FormGroup = function FormGroup(_ref) {
  var label = _ref.label,
      labelSecondary = _ref.labelSecondary,
      children = _ref.children,
      errorMessage = _ref.errorMessage,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? true : _ref$invalid,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      invalidLabelSecondary = _ref.invalidLabelSecondary;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-form-group ".concat(className, " "),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rf-form-group__inner",
    "data-v-6e52f9c7": ""
  }, label && /*#__PURE__*/React__default.createElement("label", {
    className: classnames('rf-form-group__label', disabled && 'rf-form-group__label--disabled'),
    "data-v-6e52f9c7": ""
  }, label, required && /*#__PURE__*/React__default.createElement("span", {
    className: "rf-form-group__required",
    "data-v-6e52f9c7": ""
  }, "*"), !!labelSecondary && /*#__PURE__*/React__default.createElement("span", {
    className: classnames('rf-form-group__label-secondary', disabled && 'rf-form-group__label-secondary--disabled', invalidLabelSecondary && 'rf-form-group__label-secondary--invalid'),
    "data-v-6e52f9c7": ""
  }, labelSecondary)), children), errorMessage && /*#__PURE__*/React__default.createElement("p", {
    className: classnames('rf-form-group__message', disabled && 'rf-form-group__message--disabled', invalid && 'rf-form-group__message--invalid'),
    "data-v-6e52f9c7": ""
  }, errorMessage));
};

export { FormGroup as default };
